import { REDUCER_KEY_RS } from '@Pages/RetroSynthesis/RetroSynthesisProjects/constants';
import { REDUCER_KEY_STRUCTURE_OPTIONS } from '@Pages/RetroSynthesis/StructureOption/constants';

const getRsState = (state) => state && state.get && state.get(REDUCER_KEY_RS);

const getStructureOptionsData = (state) => getRsState(state).get(REDUCER_KEY_STRUCTURE_OPTIONS);

export default function getSynthesisMenuOptions(state) {
  return getStructureOptionsData(state).synthesisMenuOptions || [];
}
